import styled from '@emotion/styled';

export const CardEmptyStateWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({theme}) => theme.gap.desktop.sm};
  padding: ${({theme}) => theme.padding.desktop.md};

  flex-direction: column;
`;

export const CardEmptyStateContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.md};
  padding: ${({theme}) => theme.padding.desktop.xl};

  // Desktop
  @media screen and (min-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    height: 244px;
  }

  // Mobile
  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    padding: ${({theme}) => theme.padding.desktop.lg};
    gap: ${({theme}) => theme.gap.desktop.md};
  }
`;
